






















import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations, Actions } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

import { DeviceInfo } from '@capacitor/device';
import { AppInfo } from '@capacitor/app';

@Component({
    computed: {
        ...mapGetters({
            currentVersion: 'User/getCurrentVersion',
            lastVersion: 'User/getLastVersion',
            availableUpdateUrl: 'User/getAvailableUpdateUrl',
        }),
    },
})
export default class AvailableUpdate extends Mixins(DeviceMethods) {
    constructor() {
        super();
    }

    public skipAvailableUpdate() {
        this.$store.commit(Mutations.SET_AVAILABLE_UPDATE_VISIBILITY, false);
    }

    public created()  {
        this.device().then((deviceInfo: DeviceInfo) => {
            this.app().then((appInfo: AppInfo) => {
                if (deviceInfo.platform === 'ios') {
                    this.$store.dispatch(Actions.GET_AVAILABLE_UPDATE_URL, appInfo.id);
                } else {
                    this.$store.commit(Mutations.SET_AVAILABLE_UPDATE_URL, `https://play.google.com/store/apps/details?id=${appInfo.id}`);
                }

            });
        });
    }
}
